
import React from 'react';
import Button from '../components/Button';
import { ARTIFACT_URL } from '../constants';
import { Copy, Crown, Star } from 'lucide-react';

const XLogo = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} width="16" height="16">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const Home: React.FC = () => {
  const handleCopy = () => {
    // Disabled copy functionality as requested
    navigator.clipboard.writeText("");
    alert("contract address coming soon...");
  };

  return (
    <div className="space-y-12">
      
      {/* Hero Section */}
      <div className="flex flex-col md:flex-row items-center gap-12">
        
        {/* The Polaroid */}
        <div className="w-full md:w-1/2 rotate-[-3deg] relative">
          <div className="bg-white p-4 pb-12 shadow-hard border-2 border-gray-200">
             <img 
               src={ARTIFACT_URL} 
               alt="Olek" 
               className="w-full aspect-square object-contain border-2 border-black bg-gray-50" 
             />
             <div className="mt-4 text-center font-comic font-bold text-2xl lowercase tracking-widest text-gray-800">
                Oleksandre (Olek)
             </div>
          </div>
          {/* Tape */}
          <div className="w-32 h-8 bg-olek-pink/50 absolute -top-4 left-1/2 -translate-x-1/2 rotate-2"></div>
          
          {/* Sticker */}
          <div className="absolute -bottom-6 -right-6 bg-money-green text-white font-bold p-4 rounded-full border-4 border-black rotate-12 shadow-hard-sm">
             RICH AF
          </div>
        </div>

        {/* The Text Scribbles */}
        <div className="w-full md:w-1/2 space-y-6">
           <h1 className="text-5xl md:text-7xl font-black lowercase leading-[0.9]">
             The <span className="text-olek-pink-dark">Hedonistic</span> <br/>
             Wojak
           </h1>
           
           <div className="p-6 border-4 border-black border-dashed bg-gray-50 rounded-lg space-y-4">
             <p className="font-bold text-xl">
               <span className="lowercase">ticker:</span> <span className="uppercase">$OLEK</span>
             </p>
             <div className="flex gap-2 flex-wrap items-center">
               <Button onClick={handleCopy} className="text-sm py-2">
                 <Copy size={16} className="inline mr-2"/> copy ca
               </Button>
               <a href="https://x.com/OleksandrePump" target="_blank" rel="noopener noreferrer">
                 <Button variant="secondary" className="text-sm py-3 px-4 flex items-center justify-center">
                   <XLogo className="w-5 h-5" />
                 </Button>
               </a>
             </div>
           </div>
        </div>

      </div>

      {/* The Manifesto / Lore */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-16">
        <div className="space-y-6 relative">
           <h2 className="text-3xl font-bold lowercase flex items-center gap-2 underline decoration-wavy decoration-olek-pink">
             <Crown className="fill-olek-pink text-black" /> who is olek?
           </h2>
           
           <p className="text-lg leading-relaxed font-medium">
             Olek (or Aleks) is the childhood friend of Wojak. But unlike Wojak, Olek 
             actually <strong>made it</strong>.
           </p>
           
           <p className="text-lg leading-relaxed">
             He comes from a well-off family, succeeds at everything he touches, and parties every weekend. 
             He is the <strong>Go-Getter</strong>. The opposite of depressed.
           </p>
        </div>

        <div className="border-4 border-black p-6 shadow-hard -rotate-1 bg-white relative overflow-hidden flex flex-col justify-between">
           <div>
             <h3 className="text-xl font-bold mb-4 bg-black text-white inline-block px-2">why he wins</h3>
             <ul className="list-disc pl-5 space-y-3 font-bold text-lg">
               <li>Cash cash cash! (Parties every weekend)</li>
               <li>Loves women (and maybe ladyboys too)</li>
               <li>Actually lives the life Wojak dreams of</li>
             </ul>
           </div>
           
           <div className="mt-8 pt-4 border-t-2 border-gray-200">
              <p className="text-xs font-bold text-gray-400 uppercase">Weakness</p>
              <p className="font-bold text-lg flex items-center gap-2">
                 Receding Hairline 
                 <span className="text-xs bg-red-100 text-red-600 px-1 border border-red-200">don't mention it</span>
              </p>
           </div>

           <div className="absolute -bottom-4 -right-4 opacity-10 rotate-12">
              <Star size={120} className="fill-black" />
           </div>
        </div>
      </div>

    </div>
  );
};

export default Home;
